import {DependencyList, useCallback, useState} from 'react';

export function useTimeoutCallback(handler: () => any, deps?: DependencyList): [(delay: number) => void, () => void] {
	const [currentTimerID, setCurrentTimerID] = useState<number>();

	const timeoutStart = useCallback((delay: number) => {
		const id = window.setTimeout(handler, delay);
		setCurrentTimerID(id);
		return id;
	}, deps || []);

	const timeoutCancel = useCallback(() => {
		clearTimeout(currentTimerID);
	}, [currentTimerID]);

	return [timeoutStart, timeoutCancel];
}
